import React from 'react'
import { Box, Rating, Snackbar, Alert } from '@mui/material';

const ToastMessage = ({open,handelClose,message,severity}) => {
  return (
    <>
       <Snackbar
              open={open}
              autoHideDuration={4000}
              onClose={() => handelClose()}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
              <Alert onClose={() => handelClose()} severity={severity} sx={{ width: '100%' }}>
                {message}
              </Alert>
            </Snackbar>
    </>
  )
}

export default ToastMessage
